import { render, staticRenderFns } from "./div-manager-review.vue?vue&type=template&id=6b602ac3&scoped=true"
import script from "./div-manager-review.vue?vue&type=script&lang=js"
export * from "./div-manager-review.vue?vue&type=script&lang=js"
import style0 from "./div-manager-review.vue?vue&type=style&index=0&id=6b602ac3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b602ac3",
  null
  
)

export default component.exports